module.exports = __webpack_public_path__ + "img/news.0fd4bf31.jpg";